<template>
  <div v-if="training._id|| !$route.query.training">
    <mdb-input label="기관" v-if="isManager" v-model="training.org.name" disabled class="w-30"/>
    <admin-org-select class="mb-4" v-if="isAdmin"  v-model="training.org" />
    <mdb-row >
      <mdb-col md="9">
        <mdb-input class="m-0" label="NCS 훈련과정" v-model="training.ncsTraining.name" disabled/>
        <!-- <mdb-input v-else class="m-0" label="NCS 훈련과정"  disabled/> -->
      </mdb-col>
      <mdb-col md="3">
        <mdb-btn icon="archway" class="m-0 p-1 mr-2"  @click="ncsModal = true">NCS 과정</mdb-btn>
        <mdb-btn icon="times" class="m-0 p-1"  color="danger" @click="training.ncsTraining={}"></mdb-btn>
      </mdb-col>
    </mdb-row>
    <small class="red-text" >※ 비 NCS 전용인 경우 선택할 필요없습니다.</small>
    <mdb-input label="개설과정명" v-model="training.name" />
    <mdb-input label="훈련대상"  v-model="training.target" />
    <mdb-row class="my-3">
      <mdb-col md="2">
        <label-select v-model="training.seq" label="차수">
          <option v-for="(seq, ix) in 30" :key="ix">{{seq}}</option>
        </label-select>
      </mdb-col>
      <mdb-col md="2">
        <label-select v-model="training.level" label="수준">
          <option v-for="(level, ix) in 10" :key="ix">{{level}}</option>
        </label-select>
      </mdb-col>
      <mdb-col md="2">
        <mdb-input type="number" label="과락기준" class="m-1"  v-model="training.failScore" />
      </mdb-col>
      <mdb-col md="2">
        <label-select v-model="training.status" label="상태">
          <option v-for="(status, sx) in ['모집중', '진행중', '종료']" :key="sx">{{status}}</option>
        </label-select>
      </mdb-col>
      <mdb-col md="4">
        <mdb-form-inline>
          <mdb-input v-if="training.teacher" label="강사" class="m-1" v-model="training.teacher.name" disabled/>
          <mdb-input v-else label="강사" class="m-1"  disabled/>
          <mdb-btn icon="chalkboard-teacher" class="m-0 p-1 mr-2"  @click="teacherModal = true">배정</mdb-btn>
          <mdb-btn icon="times" class="m-0 p-1"  color="danger" @click="training.teacher={}"></mdb-btn>
        </mdb-form-inline>
      </mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="5">
        운영년도:
        <select v-model="training.baseYear" class="select-underline">
          <option v-for="year in years" :key="year">{{year}}</option>
        </select>
      </mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2">
        <label-select v-model="training.months" label="개월수">
          <option v-for="(month, ix) in 12" :key="ix">{{month}}</option>
        </label-select>
      </mdb-col>
      <mdb-col md="2">
          <mdb-input label="훈련 시간" class="m-2"  v-model="training.hours" style="width:80px"/>
      </mdb-col>
      <mdb-col md="4">
        <date-picker label="훈련 시작일" v-model="training.startDate"/>
      </mdb-col>
      <mdb-col md="4">
        <date-picker label="훈련 종료일" v-model="training.endDate"/>
      </mdb-col>
    </mdb-row>
    <div>훈련목표</div>
    <Editor api-key="bb6a9ok4gca5sz21rpraocwpvxacglub7ukxmzxm8plvzlkz" v-model="training.objective" :init="editorInit"/>
    <ncs-training-select-dlg v-if="training.ncsTraining" :org="training.org" :show="ncsModal" v-model="training.ncsTraining" @close="ncsModal=false"/>
    <teacher-select-dlg v-model="training.teacher" :show="teacherModal" @close="teacherModal=false"/>
  </div>
</template>
<script>
import { mdbFormInline } from 'mdbvue';
import Editor from '@tinymce/tinymce-vue';
import { editorInit } from '@/views/common/config.js';
import { mapGetters } from 'vuex';
import AdminOrgSelect from '../admin/AdminOrgSelect.vue';
import LabelSelect from '@/components/common/LabelSelect'
import NcsTrainingSelectDlg from '../staff/NcsTrainingSelectDlg.vue';
import TeacherSelectDlg from '../staff/TeacherSelectDlg.vue';
import DatePicker from '../common/DatePicker.vue';
export default {
  name: 'TraingOverviewEdit',
  components: { mdbFormInline, Editor, AdminOrgSelect, LabelSelect, NcsTrainingSelectDlg, TeacherSelectDlg, DatePicker },
  props: ['training'],
  data: () => ({
    TAG: 'TraingOverviewEdit :',
    editorInit: { ...editorInit, height: '200px' },
    ncsModal: false,
    teacherModal: false
  }),
  computed: {
    ...mapGetters('auth', ['isManager', 'isAdmin']),
    years () {
      const year = new Date().getFullYear() + 1
      const years = []
      for (let i = 0; i < 10; i++) {
        years.push(year - i)
      }
      return years
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.col-label {
  text-align: right;
  font-weight: 900;
}
</style>
